<template>
  <div class="filters-mobile__first-screen">
    <div class="filters-mobile__first-screen__column">
      <div class="filters-mobile__first-screen__column__title">
        {{ $t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.title') }}
      </div>

      <CatalogFiltersMobileFirstScreenRow
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.categories')"
        row-key="categories"
        :selected-values="selectedFilters.category"
        @click="setScreenType('categories','categories')"
      />
      <CatalogFiltersMobileFirstScreenRow
        v-if="whereAreWe !== 'brand'"
        row-key="brands"
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.brand')"
        :data="filters.brand"
        :selected-values="selectedFilters.brand"
        @click="setScreenType('brand', 'brand')"
      />
      <CatalogFiltersMobileFirstScreenRow
        v-if="displaySizeFilter"
        row-key="sizes"
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.size')"
        :data="filters.size"
        :selected-values="selectedFilters.size"
        @click="setScreenType('size', 'size')"
      />
      <template
        v-for="attribute in attributes"
        :key="attribute.id"
      >
        <CatalogFiltersMobileFirstScreenRow
          v-if="attribute.showFilter"
          :title="attribute.name"
          :data="filtersByAttributes[attribute.id]"
          :selected-values="selectedFilters.filter"
          @click="setScreenType('filter', attribute.id)"
        />
      </template>
      <CatalogFiltersMobileFirstScreenRow
        row-key="productCondition"
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.productCondition')"
        :data="filters.productCondition"
        :selected-values="selectedFilters.productCondition"
        @click="setScreenType('productCondition', 'productCondition')"
      />
      <CatalogFiltersMobileFirstScreenRow
        row-key="sellerType"
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.sellerType')"
        :data="filters.isPro"
        :selected-values="[selectedFilters.isPro]"
        @click="setScreenType('isPro', 'isPro')"
      />
      <CatalogFiltersMobileFirstScreenRow
        row-key="price"
        :title="$t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.price')"
        @click="setScreenType('price', 'price')"
      />
      <div
        v-if="availableFilters.productCondition?.includes(1)"
        class="filters__badge"
      >
        {{ $t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.productCondition.new') }}
        <UIToggle v-model="productConditionNew" />
      </div>
      <div
        v-for="badge in availableBadges"
        :key="badge.id"
        class="filters__badge"
      >
        {{ badge.name }}
        <UIToggle
          :model-value="selectedFilters[badge.fieldInData]"
          @update:model-value="selectedFilters[badge.fieldInData] = $event || undefined"
        />
        <!--        <UIToggle :model-value="selectedFilters[badge.fieldInData || badge.id]" />-->
      </div>
    </div>

    <div class="filters-mobile__first-screen__column">
      <div class="filters-mobile__first-screen__column__title">
        {{ $t('components.catalog.catalogFiltersMobile.catalogFiltersMobileFirstScreen.sort') }}
      </div>

      <SortingItems />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import { TCheckboxQueryParamName } from '~/types/filters';
import { useFilters, useFiltersByAttributes } from '~/services/catalogFilter/useCatalogFilters';
import {
  useAvailableFilters,
  useStateAttributes,
  useStateAvailableFilters,
  useStateSelectedFilters,
} from '~/services/catalogFilter/useAvailableFilters';
import { useSizesFilter } from '~/services/catalogFilter/sizes';
import SortingItems from '~/components/filters/CatalogFilters/SortingItems.vue';
import { useFilterBadges } from '~/services/catalogFilter/badges';
import UIToggle from '~/components/ui/UIToggle.vue';
import CatalogFiltersMobileFirstScreenRow from './CatalogFiltersMobileFirstScreenRow.vue';

const props = defineProps<{
  modelValue?: { type: TCheckboxQueryParamName, id: TCheckboxQueryParamName | number } | undefined
  whereAreWe: TCatalogPlacing
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: {type: TCheckboxQueryParamName, id: TCheckboxQueryParamName | number}): void
}>();

const route = useRoute();
const router = useRouter();
const { productConditionNew } = useAvailableFilters(route);
const { displaySizeFilter } = useSizesFilter();

const filters = useFilters();
const attributes = useStateAttributes();
const filtersByAttributes = useFiltersByAttributes();
const availableFilters = useStateAvailableFilters();
const selectedFilters = useStateSelectedFilters();

const { availableBadges } = useFilterBadges(route, router, availableFilters);

function setScreenType(screenType: TCheckboxQueryParamName, id: TCheckboxQueryParamName | number) {
  emit('update:modelValue', {
    type: screenType,
    id,
  });
}
</script>

<style scoped lang="scss">
.filters-mobile {
  &__first-screen {
    //height: calc(100vh - 150px);
    overflow-y: auto;
    display: flex;
    gap: 20px;
    margin-top: 20px;
    padding: 40px 12px 0;
    border-top: 1px solid #e0e0e0;

    &__column {
      //flex: 1;
      width: 100%;
      max-width: 50%;

      &__title {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        text-transform: uppercase;
        letter-spacing: .3px;
        margin-bottom: 10px;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;

      &__column {
        max-width: inherit;

        &:first-child {
          order: 2;
        }
      }
    }

    &:deep(.sorting__item) {
      height: 42px;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
    }

    .filters__badge {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px 10px 0;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px;
      position: relative;

      .ui-toggle {
        position: absolute;
        right: 0;
      }
    }
  }
}
</style>
